'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconWrenchHammer, iconWrenchHammerTag } from '@ni/nimble-components/dist/esm/icons/wrench-hammer';
import { wrap } from '../../utilities/react-wrapper';

export type { IconWrenchHammer };
export { iconWrenchHammerTag };
export const NimbleIconWrenchHammer = wrap(IconWrenchHammer);